module.exports = __webpack_public_path__ + "static/media/services1.4a99feaa.png";